import { useKeenSlider } from "keen-slider/react";
import React from "react";
import { Helmet } from "react-helmet";
import BlogSlider from "../../components/BlogSlider/BlogSlider";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import Hero from "../../components/Hero/Hero";
import MeetTheTeam from "../../components/MeetTheTeam/MeetTheTeam";
import TechList from "../../components/TechList/TechList";
import TextBlock from "../../components/TextBlock/TextBlock";
import "./ServicesPage.css";

function ServicesPage() {
  const animation = { duration: 30000, easing: (t) => t };
  const [sliderRef] = useKeenSlider({
    breakpoints: {
      "(min-width: 576px)": {
        slides: { perView: 2, spacing: 15 },
      },
      "(min-width: 1024px)": {
        slides: { perView: 4, spacing: 15 },
      },
    },
    slides: {
      perView: 1,
      spacing: 15,
    },
    loop: false,
    renderMode: "performance",
    created(s) {
      s.moveToIdx(5, true, animation);
    },
    updated(s) {
      s.moveToIdx(s.track.details.abs + 5, true, animation);
    },
    animationEnded(s) {
      s.moveToIdx(s.track.details.abs + 5, true, animation);
    },
  });
  return (
    <>
     <Helmet>
        <meta charSet="utf-8" />
        <title>Services | TechFreelanceX</title>
        <meta name="description" content="TechFreelanceX is group of independent professionals who will to  work on technology projects on a freelance basis." />
      </Helmet>
      <Header />
      <Hero
        animateText={false}
        text1="We Develops"
        text2=" Digital Products and Experiences."
      />
      {/* <TextBlock
        content="Lorem ipsum dolor sit amet consectetur adipisicing elit. Nulla sequi eius ex culpa reiciendis velit obcaecati aspernatur dolorum minus excepturi aliquid, delectus iure blanditiis quia, illo temporibus praesentium minima, esse reprehenderit tempora omnis ullam optio. Id reiciendis officiis quis ipsum impedit repellendus totam ex similique aliquid veniam, iste, odio eum?" /> */}
      <section id="product-engineering" className="serviceSlider spacing">
        <TextBlock heading1="Products" heading2="Development" />
        <div className="container">
          <div className="content">
            <div className="slider keen-slider" ref={sliderRef}>
              <div className="keen-slider__slide">
                <div className="s_items ">
                  <div className="s_item_inner ">
                    <div className="title">
                      <h5>Technology</h5>
                    </div>
                    <div className="btm_title">
                      <h4>Business Applications</h4>
                    </div>
                  </div>
                </div>
              </div>
              <div className="keen-slider__slide">
                <div className="s_items ">
                  <div className="s_item_inner ">
                    <div className="title">
                      <h5>Technology</h5>
                    </div>
                    <div className="btm_title">
                      <h4>Modern Web Applications</h4>
                    </div>
                  </div>
                </div>
              </div>
              <div className="keen-slider__slide">
                <div className="s_items ">
                  <div className="s_item_inner ">
                    <div className="title">
                      <h5>Technology</h5>
                    </div>
                    <div className="btm_title">
                      <h4>Modern E-Commerce</h4>
                    </div>
                  </div>
                </div>
              </div>
              <div className="keen-slider__slide">
                <div className="s_items ">
                  <div className="s_item_inner ">
                    <div className="title">
                      <h5>Technology</h5>
                    </div>
                    <div className="btm_title">
                      <h4>Apps Development</h4>
                    </div>
                  </div>
                </div>
              </div>
              <div className="keen-slider__slide">
                <div className="s_items ">
                  <div className="s_item_inner">
                    <div className="title">
                      <h5>Technology</h5>
                    </div>
                    <div className="btm_title">
                      <h4>Hubspot CMS Development</h4>
                    </div>
                  </div>
                </div>
              </div>
              <div className="keen-slider__slide">
                <div className="s_items ">
                  <div className="s_item_inner ">
                    <div className="title">
                      <h5>Technology</h5>
                    </div>
                    <div className="btm_title">
                      <h4>Brand Portfolios</h4>
                    </div>
                  </div>
                </div>
              </div>
              <div className="keen-slider__slide">
                <div className="s_items ">
                  <div className="s_item_inner ">
                    <div className="title">
                      <h5>Technology</h5>
                    </div>
                    <div className="btm_title">
                      <h4>Rest Apis</h4>
                    </div>
                  </div>
                </div>
              </div>
              <div className="keen-slider__slide">
                <div className="s_items ">
                  <div className="s_item_inner ">
                    <div className="title">
                      <h5>Technology</h5>
                    </div>
                    <div className="btm_title">
                      <h4>Landing Pages </h4>
                    </div>
                  </div>
                </div>
              </div>
              <div className="keen-slider__slide">
                <div className="s_items ">
                  <div className="s_item_inner">
                    <div className="title">
                      <h5>Technology</h5>
                    </div>
                    <div className="btm_title">
                      <h4>Email Templates</h4>
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </section>

      <section id="customer-experience" className="serviceSlider spacing">
        <TextBlock heading1="Customer" heading2="Experience" />
        <div className="container">
          <div className="content">
            <div className="slider keen-slider" ref={sliderRef}>
              <div className="keen-slider__slide">
                <div className="s_items ">
                  <div className="s_item_inner">
                    <div className="title">
                      <h5>Design</h5>
                    </div>
                    <div className="btm_title">
                      <h4>Graphic Designer</h4>
                    </div>
                  </div>
                </div>
              </div>
              <div className="keen-slider__slide">
                <div className="s_items ">
                  <div className="s_item_inner ">
                    <div className="title">
                      <h5>Design</h5>
                    </div>
                    <div className="btm_title">
                      <h4>Digital Branding</h4>
                    </div>
                  </div>
                </div>
              </div>
              <div className="keen-slider__slide">
                <div className="s_items ">
                  <div className="s_item_inner">
                    <div className="title">
                      <h5>Design</h5>
                    </div>
                    <div className="btm_title">
                      <h4>UX Designer</h4>
                    </div>
                  </div>
                </div>
              </div>
              <div className="keen-slider__slide">
                <div className="s_items ">
                  <div className="s_item_inner">
                    <div className="title">
                      <h5>Design</h5>
                    </div>
                    <div className="btm_title">
                      <h4>UI Designer</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="digital-growth" className="serviceSlider spacing">
        <TextBlock
          heading1="Digital"
          heading2="Growth"
        />
        <div className="container">
          <div className="content">
            <div className="slider keen-slider" ref={sliderRef}>
              <div className="keen-slider__slide">
                <div className="s_items ">
                  <div className="s_item_inner ">
                    <div className="title">
                      <h5>Marketing</h5>
                    </div>
                    <div className="btm_title">
                      <h4>SEO Optimization</h4>
                    </div>
                  </div>
                </div>
              </div>
              <div className="keen-slider__slide">
                <div className="s_items ">
                  <div className="s_item_inner ">
                    <div className="title">
                      <h5>Marketing</h5>
                    </div>
                    <div className="btm_title">
                      <h4>Content Marketing</h4>
                    </div>
                  </div>
                </div>
              </div>
              <div className="keen-slider__slide">
                <div className="s_items ">
                  <div className="s_item_inner ">
                    <div className="title">
                      <h5>Marketing</h5>
                    </div>
                    <div className="btm_title">
                      <h4>Email Marketing</h4>
                    </div>
                  </div>
                </div>
              </div>
              <div className="keen-slider__slide">
                <div className="s_items ">
                  <div className="s_item_inner ">
                    <div className="title">
                      <h5>Marketing</h5>
                    </div>
                    <div className="btm_title">
                      <h4>Social Media Management</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </section>

      <TechList />
      <MeetTheTeam/>
      <BlogSlider />
      <Footer />
    </>
  );
}

export default ServicesPage;
